<template>
  <div
    id="page-login"
    style="background-image: url(http://petrol.excise-online.com/images/bg-pattern.png);"
    class="h-screen flex w-full"
  >
    <div class="vx-col mx-auto self-center">
      <center>
        <img src="http://petrol.excise-online.com/images/sappasammit.png" alt />
        <br />
        <h2 class="header-title">ระบบตรวจสอบและติดตามเรือขนส่งน้ำมัน</h2>
        <br />
        <h4 class="sub-title">
          สำนักตรวจสอบป้องกันและปราบปราม
          <br />กรมสรรพสามิต
        </h4>
        <br />
      </center>
      <div style="width:80%" class="mx-auto self-center">
        <vx-card>
          <div slot="no-body">
            <div class="vx-row">
              <div class="vx-col sm:w-full md:w-full lg:w-1/1 mx-auto self-center d-theme-dark-bg">
                <div class="p-8">
                  <div class="vx-card__title mb-8">
                    <h4 class="mb-4">Login</h4>
                  </div>
                  <vs-input
                    v-validate="'required|min:3'"
                    v-model="email"
                    data-vv-validate-on="blur"
                    name="email"
                    icon="icon icon-user"
                    icon-pack="feather"
                    label-placeholder="Username"
                    class="w-full no-icon-border"
                    @keypress.enter="login()"
                  />
                  <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                  <vs-input
                    v-validate="'required|min:3'"
                    v-model="password"
                    data-vv-validate-on="blur"
                    type="password"
                    name="password"
                    icon="icon icon-lock"
                    icon-pack="feather"
                    label-placeholder="Password"
                    class="w-full mt-6 no-icon-border"
                    @keypress.enter="login()"
                  />
                  <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                  </div>
                  <div style="display: inline-block;">
                    <vs-button style="visibility: hidden; opacity: 0;" type="border"></vs-button>
                  </div>
                  <vs-button
                    :disabled="!validateForm"
                    class="float-right"
                    @keypress.enter="login()"
                    @click="login()"
                  >Login</vs-button>
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "firebase/auth";
import { API_SIGN_OUT } from "@/constants/api";

export default {
  data() {
    return {
      reloadPage: false,
      email: "",
      password: "",
      checkbox_remember_me: false,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.email != "" && this.password != "";
    },
  },
  mounted() {
    this.$vs.loading.close();
    const url = API_SIGN_OUT();
    axios
      .delete(url, {
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken,
        },
      })
      .then((response) => {
        console.warn("success", response);
      })
      .catch((error) => {
        console.error("error", error);
      });
  },
  methods: {
    login() {
      const payload = {
        checkbox_remember_me: this.checkbox_remember_me,
        userDetails: {
          email: this.email,
          password: this.password,
        },
        notify: this.$vs.notify,
        vm: this,
      };
      this.$store.dispatch("auth/loginAttempt", payload);
    },
  },
};
</script>
<style lang="scss">
#page-login {
  .social-login {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #cc4410;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
.header-title {
  margin-top: 8px;
  font-size: calc(18px + 6 * ((100vw - 420px) / 680));
}
.sub-title {
  font-size: calc(14px + 6 * ((100vw - 420px) / 680));
}
</style>
